import { render, staticRenderFns } from "./ActivePromo.vue?vue&type=template&id=095f822c"
import script from "./ActivePromo.vue?vue&type=script&lang=js"
export * from "./ActivePromo.vue?vue&type=script&lang=js"
import style0 from "./ActivePromo.vue?vue&type=style&index=0&id=095f822c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports